import React from "react";
import { SiHubspot, SiSap } from "react-icons/si";

function SalesforceMark({ className }) {
  return (
    <svg viewBox="0 0 48 32" className={className} aria-hidden="true">
      <path
        fill="#00A1E0"
        d="M12.4 27.4c-4.4 0-8-3.4-8-7.5 0-3.2 2-5.9 4.8-7C9.4 8.7 13.4 5.8 18 5.8c1.9 0 3.7.5 5.2 1.5C24.8 4.8 28.1 3 31.8 3 37.5 3 42 7.4 42 12.8c0 .5 0 .9-.1 1.4 2.6.9 4.5 3.3 4.5 6.2 0 3.6-3.1 6.6-7.1 6.6H12.4z"
      />
      <text
        x="24"
        y="19.4"
        textAnchor="middle"
        fill="#fff"
        fontSize="6.4"
        fontWeight="700"
        fontFamily="Arial, Helvetica, sans-serif"
      >
        salesforce
      </text>
    </svg>
  );
}

export default function ConnectorLogo({ type, initials, size = "md" }) {
  const box = size === "lg" ? "h-10 w-10" : "h-9 w-9";
  const iconCls = size === "lg" ? "h-8 w-8" : "h-6 w-6";
  const kind = String(type || "").toLowerCase();

  if (kind === "salesforce") {
    return (
      <div className={`${box} flex items-center justify-center flex-shrink-0`}>
        <SalesforceMark className={size === "lg" ? "h-8 w-[48px]" : "h-7 w-10"} />
      </div>
    );
  }

  if (kind === "hubspot") {
    return (
      <div className={`${box} flex items-center justify-center flex-shrink-0 text-[#FF7A59]`}>
        <SiHubspot className={iconCls} />
      </div>
    );
  }

  if (kind === "sap") {
    return (
      <div className={`${box} flex items-center justify-center flex-shrink-0 text-[#0070F2]`}>
        <SiSap className={size === "lg" ? "h-7 w-10" : "h-6 w-8"} />
      </div>
    );
  }

  return (
    <div className={`${box} flex items-center justify-center flex-shrink-0`}>
      <span className="text-[12px] leading-[14px] font-semibold text-[#898F99] tracking-wide">
        {initials || "?"}
      </span>
    </div>
  );
}
